var time=function(ts) {
	if(!ts) return ''
	var ts=Number(ts)
    if(ts==null) return '';
    var d = new Date(ts); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = d.getFullYear() + "-";
    var M =(d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1)  : d.getMonth() + 1) + "-";
    var D = d.getDate() < 10 ? '0'+ d.getDate(): d.getDate();
    var h = d.getHours() < 10 ? '0'+ d.getHours() + ":" : d.getHours() + ":";
    var m = d.getMinutes() < 10 ? '0'+ d.getMinutes() + ":" : d.getMinutes() + ":";
    var s = d.getSeconds() < 10 ? '0'+ d.getSeconds() : d.getSeconds();
    // console.log(Y +"-" + M + "-" +D +"-"+ h +"-"+ m +"-"+ s)
    if(d.getHours()==0&&d.getMinutes()==0&&d.getSeconds()==0){
      return Y + M + D;
    }
    return Y + M + D +' '+ h + m + s;
  };
var time1=function(ts) {
	if(!ts) return ''
	var ts=Number(ts)
    if(ts==null) return '';
    var d = new Date(ts); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = d.getFullYear() + "-";
    var M =(d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1)  : d.getMonth() + 1) + "-";
    var D = d.getDate() < 10 ? '0'+ d.getDate(): d.getDate();
    return Y + M + D;
  };
  const payType = function(state,channel) {
    let str = ''
    if(state == 1 || state == 6){
      str = '支付宝'
    }else if(state==2||state==4||state==7||state==8||state==10){
      str='微信'
    }else if(state==9){
      str='赠送'
    }else if(state == 3){
        str='转账'  
    }else if(state == 11){
        str='预存支付'
      
    }
    return str
  }
	var setIdFun=function(str,status){
		var reg=/^[a-zA-Z].*/;
		var birthday='',str1='',str2='',str3='';
		var birthdayStr='';
		if(reg.test(str)){
			if(status){
				if(str.length > 18 ){
					return false
				}else{
					return true
				}
			}else{
				return false
			}
		}else{
			if(str.length == 18 || str.length == 15){
				if(str.length == 18){
					birthday=str.substring(6,14);
					str1=birthday.substring(0,4);
					str2=birthday.substring(4,6);
					str3=birthday.substring(6,8);
					if(str2>12){
						return false
					}
					if(str3>31){
						return false
					}
					birthdayStr=new Date(`${str1}-${str2}-${str3}`);
					return birthdayStr
				}else{
					birthday=str.substring(6,12);
					str1=birthday.substring(0,2);							
					str2=birthday.substring(2,4);
					str3=birthday.substring(4,6);
					if(str2>12){
						return false
					}
					if(str3>31){
						return false
					}
					birthdayStr=new Date(`19${str1}-${str2}-${str3}`);
					return birthdayStr
				}
			}else{
				return false
			}
		}				
	}			
export default { time,time1,setIdFun,payType }


// WEBPACK FOOTER //
// ./src/assets/common.js